exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Checkbox .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {\n  font-size: 13px !important;\n  color: #B6B6B6 !important;\n  text-align: left; }\n", ""]);

